module.exports = __webpack_public_path__ + "img/communication.337f7679.svg";